import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../Components/Header";
import Nav from "../Components/Nav";
import { db, auth }  from "../config"; // db = Firestore instance
import { collection, query, where, getDocs } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";

function PackageHistory() {
  const [investments, setInvestments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInvestments = async (userId) => {
      try {
        const q = query(collection(db, "investments"), where("userId", "==", userId));
        const querySnapshot = await getDocs(q);
        const fetched = querySnapshot.docs.map(doc => doc.data());
        setInvestments(fetched);
      } catch (error) {
        console.error("Error fetching investments:", error);
      } finally {
        setLoading(false);
      }
    };

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        fetchInvestments(user.uid);
      } else {
        setLoading(false);
        console.warn("No user is logged in");
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <div>
  <Helmet>
           <script src="https://forthfunded.com/assets/libs/@popperjs/core/umd/popper.min.js" />
           <script src="https://forthfunded.com/assets/libs/bootstrap/js/bootstrap.bundle.min.js" />
           <script src="https://forthfunded.com/assets/js/defaultmenu.min.js" />
           <script src="https://forthfunded.com/assets/libs/node-waves/waves.min.js" />
           <script src="https://forthfunded.com/assets/js/sticky.js" />
           <script src="https://forthfunded.com/assets/libs/simplebar/simplebar.min.js" />
           <script src="https://forthfunded.com/assets/js/simplebar.js" />
           <script src="https://forthfunded.com/assets/libs/@simonwep/pickr/pickr.es5.min.js" />
           <script src="https://forthfunded.com/assets/libs/apexcharts/apexcharts.min.js" />
           <script src="https://forthfunded.com/assets/js/crypto-dashboard.js" />
           <script src="https://forthfunded.com/assets/js/custom-switcher.min.js" />
           <script src="https://forthfunded.com/assets/js/custom.js" />
         </Helmet>

      <div className="page">
        <Header />
        <Nav />
        <div className="main-content app-content">
          <div className="container-fluid">
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <h1 className="page-title fw-semibold fs-18 mb-0">Package History</h1>
              <div className="ms-md-1 ms-0">
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item"><a href="/">Dashboard</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Package History</li>
                  </ol>
                </nav>
              </div>
            </div>

            <div className="row">
              <div className="col-xl-12">
                <div className="card custom-card">
                  <div className="card-body">
                    <div className="table-responsive">
                      {loading ? (
                        <p>Loading investments...</p>
                      ) : investments.length === 0 ? (
                        <p>No investments found.</p>
                      ) : (
                        <table className="table table-bordered text-nowrap w-100">
                          <thead>
                            <tr>
                              <th>Plan</th>
                              <th>Amount</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {investments.map((inv, idx) => (
                              <tr key={idx}>
                                <td>{inv.plan}</td>
                                <td>${inv.amount.toLocaleString()}</td>
                                <td>
                                  <span className={`badge bg-${inv.status === "Active" ? "success" : "secondary"}`}>
                                    {inv.status}
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <footer className="footer mt-auto py-3 bg-white text-center">
          <div className="container">
            <span className="text-muted">Copyright © 2025</span>{" "}
            <a href="#" className="text-dark fw-semibold">FarYieldFi</a>. All Rights Reserved
          </div>
        </footer>
      </div>
    </div>
  );
}

export default PackageHistory;
